import React, {PropTypes} from 'react';
import {connect} from 'react-redux';

import * as commonActionCreators from '../../../actions/common';
let allActionCreators = Object.assign({}, commonActionCreators);

class ProductPage extends React.Component {

	constructor(props) {
		super(props);
    this.state = {};
	}

  componentDidMount() {
    // this.props.setWhiteBg(this.props.gbWhite);
  }

  openContact() {
    this.props.commonOpenContact(this.props.product);
  }

  renderCopy(productObj) { 
    if(!productObj) {
      return null;
    }

    if(productObj.copy.length === 1) {
      return this.renderSingle(productObj);
    }

    if(productObj.copy.length == 2) {
      return this.renderDouble(productObj);
    }

    if(productObj.copy.length == 3) {
      return this.renderTriple(productObj);
    }
  }

  renderSingle(productObj) { 
    return <div className='copyWrapper'>
      <div className='productNumber'>{productObj.pages[0]}</div>
      <div className='productLine'>
        <img src='/img/dallas2020/assets/iconline.svg' />
      </div>
      <div className='singleCopy'>{productObj.copy[0]}</div>
    </div>;
  }

  renderDouble(productObj) { 
    return <div className={'copyWrapper copyMultiple'}>
      <div className='copyItem'>
        <div className='copyNum'>{productObj.pages[0]}</div>
        <div className='copyBody'>{productObj.copy[0]}</div>
      </div>
      <div className='productLine'>
        <img src='/img/dallas2020/assets/iconline.svg' />
      </div>
      <div className='copyItem'>
        <div className='copyNum'>{productObj.pages[1]}</div>
        <div className='copyBody'>{productObj.copy[1]}</div>
      </div>
    </div>;
  }

  renderTriple(productObj) { 
    return <div className={'copyWrapper copyMultiple copyTriple'}>
      <div className='copyItem'>
        <div className='copyNum'>{productObj.pages[0]}</div>
        <div className='copyBody'>{productObj.copy[0]}</div>
      </div>
      <div className='productLine'>
        <img src='/img/dallas2020/assets/iconline.svg' />
      </div>
      <div className='copyItem'>
        <div className='copyNum'>{productObj.pages[1]}</div>
        <div className='copyBody'>{productObj.copy[1]}</div>
      </div>
      <div className='productLine'>
        <img src='/img/dallas2020/assets/iconline.svg' />
      </div>
      <div className='copyItem'>
        <div className='copyNum'>{productObj.pages[2]}</div>
        <div className='copyBody'>{productObj.copy[2]}</div>
      </div>
    </div>;
  }

  renderSlider() {
    const settings = {
      dots: false,
      infinite: true,
      slidesToShow: 1,
      slidesToScroll: 1,
      autoplay: false,
      speed: 500,
      cssEase: "linear",
      arrows: false,
      adaptiveHeight: true,
    };
      return <div className='homeRotatingBanner'>
      <div className="bannerLeft" onClick={::this.prevSlide}>
        <div className="leftArrow"></div>
      </div>
      <div className="bannerRight" onClick={::this.nextSlide}>
        <div className="rightArrow"></div>
      </div>
      <Slider ref={(slider) => { this.sliderObject = slider; }} {...settings}>
        <div className={'homeBanner rotatingBannerItem'}>
          <video className='desktop600' autoPlay playsInline muted="muted" loop id="videobanner" ref={(vid) => { this.homeDesktop = vid; }}>
            <source src="https://ddw2.diamondsdirect.com/img/promopages/holiday2020/dec/home/homepage.mp4" type="video/mp4" />
          </video>
          <video className='mobile600' autoPlay playsInline muted="muted" loop id="videobanner" ref={(vid) => { this.homeDesktop = vid; }}>
            <source src="https://ddw2.diamondsdirect.com/img/promopages/holiday2020/dec/home/homepage_mob.mp4" type="video/mp4" />
          </video>
          <div className={'summer2020BannerOverlay bannerOverlay desktop600'}>
            <div className='summer2020BannerButton' onClick={() => this.internalNav('holiday')}>*Go to Financing Terms</div>
          </div>
          <div className={'summer2020BannerOverlay bannerOverlay mobile600'}>
            <div className='summer2020BannerButton' onClick={() => this.internalNav('holiday')}>*Go to Financing Terms</div>
          </div>
        </div>
        <div className={'homeBanner rotatingBannerItem'}>
          <video className='desktop600' autoPlay playsInline muted="muted" loop id="videobanner" ref={(vid) => { this.homeDesktop = vid; }}>
            <source src="https://ddw2.diamondsdirect.com/img/promopages/holiday2020/earring/homeapge/homepage.mp4" type="video/mp4" />
          </video>
          <video className='mobile600' autoPlay playsInline muted="muted" loop id="videobanner" ref={(vid) => { this.homeDesktop = vid; }}>
            <source src="https://ddw2.diamondsdirect.com/img/promopages/holiday2020/earring/homeapge/homepage_mob.mp4" type="video/mp4" />
          </video>
          <div className={'earring2020BannerOverlay bannerOverlay desktop600'}>
            <div className='earring2020BannerButton' onClick={() => this.internalNav('holiday?highlight=earring')}>Learn More</div>
          </div>
          <div className={'earring2020BannerOverlay bannerOverlay mobile600'}>
            <div className='earring2020BannerButton' onClick={() => this.internalNav('holiday?highlight=earring')}>Learn More</div>
          </div>
        </div>
      </Slider>
    </div>;
  }

	render() {
		return <div className={'ProductPage pageContent'}>
      <div className='imageWrapper'>
      	<img src={this.props.product.image} />
        <div className='contactIcon' onClick={::this.openContact}>
          <img src='/img/svg/bag.svg' />
          <div className='contactLabel'>
            <div className='innerWrapper'>
              See in person
            </div>
          </div>
        </div>
        {this.props.product.copy && !this.props.showNoCopy ? 
          <div className='imageCaption'>
            {this.renderCopy(this.props.product)}
          </div> :
          null
        }
      </div>
		</div>;
	}
}
export default ProductPage;

function mapStateToProps(state) {
  return {
    common: state.common,
  };
}

export const ProductPageContainer = connect(
  mapStateToProps,
  allActionCreators
)(ProductPage);


// WEBPACK FOOTER //
// ./src/components/views/page/ProductPage.jsx